import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Такой страницы у нас нет',
} satisfies TMessages
